// extracted by mini-css-extract-plugin
export default {"ArrivalsDeparturesBoard":"ArrivalsDeparturesBoard_ArrivalsDeparturesBoard__ODRjN"};